export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.30f9cbc3.ttf";